import { CodeBase } from "./_codeBase";

export type ViewProgressConditionDivCode = '01' | '02' | '03' | '04';

/** ビュー進捗表条件区分*/
export class ViewProgressConditionDiv extends CodeBase<ViewProgressConditionDiv>
{
    /** ビュー進捗表条件区分: "01", "プラントカテゴリ会社範囲"*/
    public static readonly PLANT_CATEGORY_COMPANY_RANGE: ViewProgressConditionDiv = new ViewProgressConditionDiv("01" as ViewProgressConditionDivCode, "プラントカテゴリ会社範囲", "");
    /** ビュー進捗表条件区分: "02", "機器指定（関連文字検索）"*/
    public static readonly EQUIPMENT_DESIGN: ViewProgressConditionDiv = new ViewProgressConditionDiv("02" as ViewProgressConditionDivCode, "機器指定（関連文字検索）", "");
    /** ビュー進捗表条件区分: "03", "機器担当指定"*/
    public static readonly EQUIPMENT_CHARGE_DESIGN: ViewProgressConditionDiv = new ViewProgressConditionDiv("03" as ViewProgressConditionDivCode, "機器担当指定", "");
    /** ビュー進捗表条件区分: "04", "作業項目指定"*/
    public static readonly WORK_ITEM_DESIGN: ViewProgressConditionDiv = new ViewProgressConditionDiv("04" as ViewProgressConditionDivCode, "作業項目指定", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ViewProgressConditionDiv[] {
        return [
            ViewProgressConditionDiv.PLANT_CATEGORY_COMPANY_RANGE,
            ViewProgressConditionDiv.EQUIPMENT_DESIGN,
            ViewProgressConditionDiv.EQUIPMENT_CHARGE_DESIGN,
            ViewProgressConditionDiv.WORK_ITEM_DESIGN
        ];
    }
}
